import { Result } from 'antd';
export { IconMap, ExceptionMap } from 'antd/es/result';
export default Result;
